"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgElipsisHeavy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M4.45 10c1.373 0 2.25.934 2.25 2.244S5.823 14.5 4.45 14.5c-1.36 0-2.25-.947-2.25-2.256 0-1.31.89-2.244 2.25-2.244zm7.5 0c1.373 0 2.25.934 2.25 2.244s-.877 2.256-2.25 2.256c-1.36 0-2.25-.947-2.25-2.256 0-1.31.89-2.244 2.25-2.244zm7.5 0c1.373 0 2.25.934 2.25 2.244s-.877 2.256-2.25 2.256c-1.36 0-2.25-.947-2.25-2.256 0-1.31.89-2.244 2.25-2.244z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgElipsisHeavy;
exports.default = _default;